import { Injectable } from "@angular/core";
import { Response, ResponseContentType } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Constants } from "../constants/constants";
import { HttpClient } from "../authentication/httpClient";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";

@Injectable()
export class PurchaseHistoryService {

    constructor(private http: HttpClient) { }

	getPurchaseHistory(username: string, pageNumber: number, pageSize: number): Observable<{ purchases: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetPurchaseHistory/${username}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getPurchaseHistorySearch(username: string, pageNumber: number, pageSize: number, search: string): Observable<{ purchases: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetPurchaseHistory/${username}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getSavedPurchases(username: string, pageNumber: number, pageSize: number): Observable<{ purchases: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetSavedPurchases/${username}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getSavedPurchasesSearch(purchaserEmail: string, pageNumber: number, pageSize: number): Observable<{ history: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetSavedPurchases/${purchaserEmail}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getCompletedPurchaseHistory(username: string, pageNumber: number, pageSize: number): Observable<{ purchases: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetCompletedPurchaseHistory/${username}/${pageNumber}/${pageSize}`, {}).map((res: Response) => res.json()).catch(this.handleError);
	}

	getCompletedPurchaseHistorySearch(username: string, pageNumber: number, pageSize: number, search: string): Observable<{ purchases: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetCompletedPurchaseHistory/${username}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getManagerApprovals(managerEmail: string, pageNumber: number, pageSize: number): Observable<{ approvals: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetManagerApprovals/${managerEmail}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getManagerApprovalsSearch(managerEmail: string, pageNumber: number, pageSize: number, search: string): Observable<{ approvals: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetManagerApprovals/${managerEmail}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getManagerApprovalHistory(managerEmail: string, pageNumber: number, pageSize: number): Observable<{ history: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetManagerApprovalHistory/${managerEmail}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getHasManagerApprovals(managerEmail: string): Observable<boolean> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetHasManagerApprovals/${managerEmail}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getManagerApprovalHistorySearch(managerEmail: string, pageNumber: number, pageSize: number, search: string): Observable<{ history: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetManagerApprovalHistory/${managerEmail}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getPurchaserApprovals(purchaserEmail: string, pageNumber: number, pageSize: number): Observable<{ approvals: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetPurchaserApprovals/${purchaserEmail}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getPurchaserApprovalsSearch(purchaserEmail: string, pageNumber: number, pageSize: number, search: string): Observable<{ approvals: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetPurchaserApprovals/${purchaserEmail}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getPurchaserHistory(purchaserEmail: string, pageNumber: number, pageSize: number): Observable<{ history: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetPurchaserHistory/${purchaserEmail}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getPurchaserHistorySearch(purchaserEmail: string, pageNumber: number, pageSize: number, search: string): Observable<{ history: Array<IPurchaseHistoryModel>, rowCount: number }> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetPurchaserHistory/${purchaserEmail}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getPurchasers(): Observable<Array<IUserModel>> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/GetPurchasers`).map((res: Response) => res.json()).catch(this.handleError);
	}

    updateApprovalStatus(approvalId: number, toFormStatusId: number, username: string): Observable<boolean> {
        return this.http.put(`${Constants.restUrl}PurchaseHistory/UpdateApprovalStatus/${approvalId}/${toFormStatusId}/${username}`, {}).map((res: Response) => res.json()).catch(this.handleError);
	}
	updateManagerComment(approvalId: number, approvalManagerComment: string, glCode: string): Observable<boolean>{
		if (glCode)
			return this.http.put(`${Constants.restUrl}PurchaseHistory/UpdateManagerComment/${approvalId}/${approvalManagerComment}/${glCode}`, {}).map((res: Response) => res.json()).catch(this.handleError);
		else
			return this.http.put(`${Constants.restUrl}PurchaseHistory/UpdateManagerComment/${approvalId}/${approvalManagerComment}`, {}).map((res: Response) => res.json()).catch(this.handleError);
    }

	updatePurchaser(approvalId: number, purchaserId: number): Observable<boolean> {
		return this.http.put(`${Constants.restUrl}PurchaseHistory/UpdatePurchaser/${approvalId}/${purchaserId}`, {}).map((res: Response) => res.json()).catch(this.handleError);
	}

	updatePurchaseItems(items: Array<IItemModal>): Observable<boolean> {
		return this.http.put(`${Constants.restUrl}PurchaseHistory/UpdatePurchaseItems`, items).map((res: Response) => res.json()).catch(this.handleError);
	}

	purchaserUpdatePurchase(history: IPurchaseHistoryModel): Observable<boolean> {
		return this.http.put(`${Constants.restUrl}PurchaseHistory/PurchaserUpdatePurchase`, history).map((res: Response) => res.json()).catch(this.handleError);
	}

	getPurchaseById(approvalId: number): Observable<IPurchaseHistoryModel> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/getPurchaseById/${approvalId}`, {}).map((res: Response) => res.json()).catch(this.handleError);
	}

	canEditPurchase(username: string, approvalId: number): Observable<boolean> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/CanEditPurchase/${username}/${approvalId}`, {}).map((res: Response) => res.json()).catch(this.handleError);
	}
	getattachment(approvalId: number): Observable<boolean> {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/getattachment/${approvalId}`, {}).map((res: Response) => res.json()).catch(this.handleError);
	}
	downloadAttachment(formTypeId: number,approvalId:number,fileName: string) {
		return this.http.get(`${Constants.restUrl}PurchaseHistory/downloadfile/${formTypeId}/${approvalId}/${fileName}`, {
			responseType: ResponseContentType.Blob // Set response type to Blob for binary file data
		}).map((res: Response) => {
			const contentType = res.headers.get('Content-Type') || 'application/octet-stream';
			const blob = res.blob();
			return new Blob([blob], { type: contentType });
		});
	}

	private handleError(error: any): Observable<any> {
		console.error("An error occurred", error);
		return Observable.throw(error.message || error);
	}
}